// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".custon-chip-header.sub-chip{margin-left:30px;margin-top:3px;position:relative;z-index:1}.custon-chip-header.sub-chip .avatar{height:17px!important;left:-7px;position:absolute;top:-7px;width:17px!important}.custon-chip-header.sub-chip.has-icon .avatar{height:22px!important;left:-9px;top:-9px;width:22px!important}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
